<template>
  <div style="text-align: center" :style="{ width: width + 'px' }">
    <div class="gauge" :style="{ width: width + 'px', height: width + 'px' }">
      <img :src="src" />
      <img src="@/assets/svgs/仪表盘_指针.svg" ref="chart_point" />
      <div v-if="showInCenter"
        style="font-size: 20px; font-weight: bold; color: #2a7aff; z-index: 999;position: absolute;    "
        :style="{ top: (width / 4 + 10) + 'px' }">
        {{ value }}
      </div>
    </div>

    <div v-if="!showInCenter" :style="{ color: color }" style="
        font-size: 14px;
        color: #0f1a3a;
        line-height: 14px;
        margin-top: 8px;
        font-weight: bold;
      ">
      {{ value }}{{ unit }}
    </div>
    <div v-if="!showInCenter" style="
        opacity: 0.5;
        font-size: 12px;
        color: #0f1a3a;
        line-height: 12px;
        margin-top: 8px;
      ">
      {{ title }}
    </div>
  </div>
</template>
<script>
import anime from "animejs/lib/anime.es.js";

export default {
  props: {
    showInCenter: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
    unit: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "#0F1A3A",
    },
    type: {
      type: String,
      default: "motor_temperature",
    },
    width: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {};
  },
  methods: {
    transform(v) {
      switch (this.type) {
        case "battery_temperature":
          v = v + 40; //电池温度 -40~80
          break;
        case "motor_temperature":
          v = v + 40; //电池温度 -40~180  220
          break;
        case "motor_speed":
          v = v / 100; // 0~5000
          break;
      }
      return v * this.rate + this.base;
    },
  },
  watch: {
    value() {
      anime({
        targets: this.$refs.chart_point,
        rotate: this.transform(this.value),
        duration: 800,
        easing: "easeInOutSine",
      });
    },
  },
  mounted() {
    if (this.value != null && this.value != undefined) {
      anime({
        targets: this.$refs.chart_point,
        rotate: this.transform(this.value),
        duration: 800,
        easing: "easeInOutSine",
      });
    }
  },
  computed: {
    base() {
      switch (this.type) {
        case "speed":
          return 38;
        case "motor_speed":
          return 30; //电机转速
        case "battery_temperature":
          return 44; //电池温度
        case "motor_temperature":
          return 32; //电机温度
        case "consumptionPer100km_eng":
          return 32; //百公里电耗
        case "consumptionPer100km":
          return 30; //百公里油耗
      }
      return 0;
    },
    rate() {
      switch (this.type) {
        case "speed":
          return 2.02; //车速
        case "motor_speed":
          return 6; //转速
        case "battery_temperature":
          return 2.27; // 电池温度
        case "motor_temperature":
          return 1.34; //电机温度
        case "consumptionPer100km_eng":
          return 2.94; //百公里电耗
        case "consumptionPer100km":
          return 6; //百公里油耗
      }
      return 0;
    },
    src() {
      switch (this.type) {
        case "speed":
          return require("@/assets/svgs/仪表盘_车速.svg");
        case "battery_temperature":
          return require("@/assets/svgs/仪表盘_电池温度.svg");
        case "motor_temperature":
          return require("@/assets/svgs/仪表盘_电机温度.svg");
        case "motor_speed":
          return require("@/assets/svgs/仪表盘_电机转速.svg");
        case "consumptionPer100km_eng"://百公里电耗

          return require("@/assets/svgs/pic_nenghaobiao.png");
        case "consumptionPer100km"://百公里油耗

          return require("@/assets/svgs/pic_youhaobiao.png");

      }
      return "";
    },
  },
};
</script>
<style scoped>
.gauge {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gauge img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
</style>
